<section>
  <div class="container mt-3">
    <form>
      <button class="btn btn-success" (click)="open(0)">Nuevo</button>
      <table class="table mt-3 table-hover table-sm table-responsive table-bordered border-dark">
        <thead class="table-dark">
          <tr>
            <th scope="col">SR</th>
            <th scope="col">Nombre</th>
            <th scope="col">DNI</th>
            <th scope="col">Direccion</th>
            <th scope="col">Demora</th>
            <th scope="col">Fecha Solicitada</th>
            <th scope="col">Estado</th>
            <th scope="col">ET Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody class="table-light">

          <tr *ngFor="let m of sr" >
            <th class={{m.estilo}}>SR-{{m.id| number:'6.0':'fr'}}</th>
            <th class={{m.estilo}}>{{m.nombreApellido}}</th>
            <th class={{m.estilo}}>{{m.dni}}</th>
            <th class={{m.estilo}}>{{m.DIRECCION}}</th>
            <th *ngIf="m.demora>5" class="text-center bg-warning">{{m.demora}}</th>
            <th *ngIf="m.demora<=5" class="text-center">{{m.demora}}</th>
            <th class={{m.estilo}}>{{m.created_at}}</th>
            <th class={{m.estilo}}>{{m.estadoDescripcion}}</th>
            <th class={{m.estilo}}>{{m.etEstadoDescripcion}}</th>
            <!--Si demora > 5 dias-->
            <th class={{m.estilo}}>
              <div class="btn-group" role="group" aria-label="Basic example">
                <button *ngIf="(m.estado===1)" type="button" class="btn btn-primary btn-sm" (click)="cambiarEstado(m.id,2)">Aprobar</button>
                <button *ngIf="(m.estado===2)" type="button" class="btn btn-success btn-sm" (click)="abrirEt(m.id)">Recibir</button>
                <button *ngIf="(m.estado===3)" type="button" class="btn btn-success btn-sm" (click)="abrirEtM(m.id_et, m.id)">ET-{{m.id_et| number:'6.0':'fr'}}</button>
                <button type="button" class="btn btn-warning btn-sm" (click)="open(m.id)">Modificar</button>
                <button  type="button" class="btn btn-danger btn-sm" (click)="cambiarEstado(m.id,4)">Cancelar</button>
              </div>
            </th>
            <!-- <th *ngIf="m.demora<=5" class={{m.estilo}}>SR-{{m.id| number:'6.0':'fr'}}</th>
            <th *ngIf="m.demora<=5" class={{m.estilo}}>{{m.nombreApellido}}</th>
            <th *ngIf="m.demora<=5" class={{m.estilo}}>{{m.dni}}</th>
            <th *ngIf="m.demora<=5" class={{m.estilo}}>{{m.DIRECCION}}</th>
            <th *ngIf="m.demora<=5" class="text-center">{{m.demora}}</th>
            <th *ngIf="m.demora<=5">{{m.created_at}}</th>
            <th *ngIf="m.demora<=5">{{m.estadoDescripcion}}</th>
            <th *ngIf="m.demora<=5" >{{m.etEstadoDescripcion}}</th>
            Si demora <= 5 dias
            <th *ngIf="(m.demora<=5)" >
              <div class="btn-group" role="group" aria-label="Basic example">
                <button *ngIf="(m.estado===1)" type="button" class="btn btn-primary btn-sm" (click)="cambiarEstado(m.id,2)">Aprobar</button>
                <button *ngIf="(m.estado===2)" type="button" class="btn btn-success btn-sm" (click)="abrirEt(m.id)">Recibir</button>
                <button *ngIf="(m.estado===3)" type="button" class="btn btn-success btn-sm" (click)="abrirEtM(m.id_et, m.id)">ET-{{m.id_et| number:'6.0':'fr'}}</button>
                <button type="button" class="btn btn-warning btn-sm" (click)="open(m.id)">Modificar</button>
                <button  type="button" class="btn btn-danger btn-sm" (click)="cambiarEstado(m.id,4)">Cancelar</button>
              </div>
            </th> -->

          </tr>

        </tbody>
      </table>
    </form>
  </div>
</section>
